import { api } from '../config/api'

const baseEndpoint = '/SharingGroupApi'

export const createSharingGroup = (data) =>
  api.post(`${baseEndpoint}/Create`, data)

export const getSharingGroupsByOwner = (ownerId) =>
  api.get(`${baseEndpoint}/GetByOwner`, { params: { ownerId } })

export const getSharingGroup = (groupId) =>
  api.get(`${baseEndpoint}/${groupId}`)

export const editSharingGroup = ({ groupId, sharinGroup }) =>
  api.put(`${baseEndpoint}/${groupId}/Edit`, sharinGroup)

export const deleteSharingGroup = (groupId) =>
  api.delete(`${baseEndpoint}/${groupId}`)

export const removeSharingGroupMembers = ({ groupId, members }) =>
  api.put(`${baseEndpoint}/${groupId}/RemoveMembers`, members)

export const addSharingGroupMembers = ({ groupId, members }) =>
  api.put(`${baseEndpoint}/${groupId}/AddMembers`, members)
